import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function usePoll(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchPoll() {
    setLoading(true);
    const { response, data } = await API.fetchPoll(token, id);

    if (response.ok) {
      setResult(data);
      setLoading(false);
      setError(null);
    } else {
      setError({ status: response.status, ...data });
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchPoll();
  }, [id]);

  const refresh = useCallback(() => fetchPoll(), [id]);

  return {
    loading,
    error,
    refresh,
    poll: result,
  };
}
